export const MY_AVAILABILITY_SLICE = 'myAvailability' as const;

export const INTERNAL_TIME_SLOTS = Array(48)
  .fill(null)
  .map((_, i) => {
    const hour = Math.floor(i / 2);
    const minute = (i % 2) * 30;
    return { hour, minute };
  });
